// extracted by mini-css-extract-plugin
export default {"SocialIcon":"SocialIcon_SocialIcon__LjHUi"};